import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=780958d1&"
import script from "./AdminList.vue?vue&type=script&lang=ts&"
export * from "./AdminList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports